import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router-dom';
import hoverApartmentAction from "../../actions/hoverApartmentAction";
import hoverRemoveApartmentAction from "../../actions/hoverRemoveApartmentAction";

const _ApartmentSelectPage = (props) => {
    // because of the labeling, we need to do some sorting to get the level array in the right order
    let sorted = Object.keys(props.blob.levels).sort();
    let end = sorted.pop();
    sorted.unshift(end);

    // shortcut variable for referencing the currently selected apartment
    let selectedLevel = props.blob.levels[props.match.params.aptLevel];
    let apartments = Object.keys(selectedLevel.apartments);

    // the below variables provide defaults that prevent null errors when the hover box is not being displayed
    let hoverBoxPosition = { top: `0`, left: `0` };
    let hoveredApt = { "apartment": "", "type": "", "bed": "", "bath": "", "study": "", "internal": "", "terrace": "", "external": "", "total": "", "level": "" };
    if(props.hovered) {
        // if the hoverbox is being displayed, store the payload values for ease-of-access
        hoverBoxPosition = props.hovered.popupBoxPosition;
        hoveredApt = props.hovered.apt;
    }

    setTimeout(() => {
        document.querySelectorAll('.sold-box,.hold-box').forEach((elem) => {
            let key = elem.getAttribute('data-key');
            let apt = selectedLevel.apartments[key];
            props.onSoldButtonLoaded(apt, elem);
        });

        document.querySelectorAll('.ispi-floorplan-hoverbox').forEach((elem) => {
            let key = elem.getAttribute('data-boxkey');
            let apt = selectedLevel.apartments[key];
            props.onSideBoxLoaded(apt, elem);
        });
    }, 200);

    window.timeout = null;
    window.addEventListener('resize', () => {
        // clear the timeout
        clearTimeout(window.timeout);
        // start timing for event "completion"
        window.timeout = setTimeout(() => {
            document.querySelectorAll('.ispi-floorplan-hoverbox').forEach((elem) => {
                let key = elem.getAttribute('data-boxkey');
                let apt = selectedLevel.apartments[key];
                props.onSideBoxLoaded(apt, elem);
            });
        }, 250);
    });

    return (
        <div className="full-width">
            <div className="ispi-breadcrumbs">
                <a href="/apartments">apartments</a>&nbsp;>&nbsp;<span>LEVEL {props.match.params.aptLevel}</span>
            </div>
            <div className="ispi-floorplan-container">
                <div className="ispi-interactive-plan-container">
                    {apartments.map((apt, idx) =>
                        <Link key={idx} data-boxkey={selectedLevel.apartments[apt].apartment} className="ispi-floorplan-hoverbox visible" to={`/apartments/level/${props.match.params.aptLevel}/apartment/${selectedLevel.apartments[apt].apartment.replace('.', '-')}`} onMouseOver={selectedLevel.apartments[apt].status === 1 ? props.onHoverApartment(selectedLevel.apartments[apt]) : null} onMouseOut={selectedLevel.apartments[apt].status === 1 ? props.onHoverRemoveApartment(selectedLevel.apartments[apt]) : null}>
                            <p className="ispi-floorplan-hoverbox-line">
                                <span className="ispi-floorplan-hoverbox-label">apartment</span>&nbsp;<span className="ispi-floorplan-hoverbox-value">{selectedLevel.apartments[apt].apartment}</span>
                            </p>

                            <p className="ispi-floorplan-hoverbox-line">
                                <span className="ispi-floorplan-hoverbox-label">{ selectedLevel.apartments[apt].study !== 0 ? `${selectedLevel.apartments[apt].bed} BED / ${selectedLevel.apartments[apt].bath} BATH / STUDY` : `${selectedLevel.apartments[apt].bed} BED / ${selectedLevel.apartments[apt].bath} BATH` }</span>
                            </p>

                            <p className="ispi-floorplan-hoverbox-line" style={{marginTop: '4px'}}>
                                <span className="ispi-floorplan-hoverbox-label" style={{textDecoration: 'underline'}}>VIEW APARTMENT</span>
                            </p>

                            <div className="hoverbox-pointer" />
                        </Link>
                    )}
                    <img className="ispi-interactive-plan-container-img" src={selectedLevel.img} />
                    <svg className="ispi-interactive-plan-container-svg" viewBox="0 0 1400 1000">
                        {apartments.map(apt =>
                            <polygon
                                key={apt}
                                data-key={apt}
                                className={selectedLevel.apartments[apt].status === 1 ? selectedLevel.apartments[apt].apartment === hoveredApt.apartment ? "polygon-hoverable hovered" : "polygon-hoverable" : "polygon-static"}
                                points={selectedLevel.apartments[apt].coords}
                                onClick={selectedLevel.apartments[apt].status === 1 ? props.onApartmentSelected(props.match.params.aptLevel, apt) : null}
                                onMouseOver={selectedLevel.apartments[apt].status === 1 ? props.onHoverApartment(selectedLevel.apartments[apt]) : null}
                                onMouseOut={selectedLevel.apartments[apt].status === 1 ? props.onHoverRemoveApartment(selectedLevel.apartments[apt]) : null}/>
                        )}
                    </svg>
                    {apartments.map(apt =>
                       <div key={apt} data-key={apt} className={selectedLevel.apartments[apt].status === 1 || selectedLevel.apartments[apt].status === 2 ? "sold-box" : "hold-box" }>
                            {selectedLevel.apartments[apt].status === 1 ? `` : selectedLevel.apartments[apt].status === 2 ? `SOLD` : `HOLD`}
                       </div>
                    )}
                    <span className="ispi-interactive-usage-tip">Usage Tip: Hover and click to interact with floorplans</span>
                </div>
            </div>
            <div className="ispi-floorlabel-container colour-bg-lg font-mb fontsize-med">LEVEL {props.match.params.aptLevel}</div>
            <div className="full-width">
                <div className="ispi-apartment-floor-select-container">
                    <ul className="ispi-apartment-select-columnar">
                        {sorted.map(lvl =>
                            <li className="font-mm colour-bg-lg gr-btn-hover" key={lvl} onClick={props.onLevelSelect(lvl)}>LEVEL {lvl}</li>
                        )}
                    </ul>
                    <ul className="ispi-apartment-mobile-select">
                        {apartments.map(apt =>
                            <li className="font-mm colour-bg-lg gr-btn-hover" key={apt} onClick={props.onApartmentSelected(props.match.params.aptLevel, apt)}>
                                &nbsp;
                                <span className="left-align">APARTMENT {apt}</span>
                                <span className="right-align">{ selectedLevel.apartments[apt].study !== 0 ? `${selectedLevel.apartments[apt].bed} BED / ${selectedLevel.apartments[apt].bath} BATH / STUDY` : `${selectedLevel.apartments[apt].bed} BED / ${selectedLevel.apartments[apt].bath} BATH` }</span>
                            </li>
                        )}
                    </ul>
                </div>
                <div className="ispi-apartment-disclaimer-container">
                    <a className="download-pdf-btn" href={selectedLevel.pdf} target="_blank">DOWNLOAD BROCHURE</a>
                    <div className="disclaimer">
                        These plans are intended as a guide only. The dimensions and areas are approximate only and may not accurately represent the actual dimensions and areas of the apartments or the spaces within them and are subject to change without notice. In addition, locations of utilities may vary during construction and fittings and fixtures on these plans are for illustrative purposes only. The areas are generally measured in accordance with the Property Council of Australia method of measurement. Prospective purchasers must rely on their own enquiries and should refer to the Contract of Sale and its schedules for all matters to be included in the purchase price of the apartment, including plans, finishes, fixtures, fittings, appliances and other particulars of sale. Loose furniture and planters are not included. Extent of floor finishes may vary. External space and landscaping indicative only. Refer to level plans for further information.
                    </div>
                </div>
            </div>
        </div>
    );
};

// map the blob object in the state to the props param
const mapStateToProps = state => {
    return {
        blob: state.data.blob,
        hovered: state.data.hovered
    };
};

// define the following functions as available from the props param
const mapDispatchToProps = dispatch => {
    return {
        onApartmentSelected: (selectedLvl, selectedApt) => {
            // return an onClick usable function that changes routes
            return () => {
                dispatch(hoverRemoveApartmentAction(null)); // dispatch a remove hover action to ensure if we navigate back, the hover is cleared
                dispatch(push(`/apartments/level/${selectedLvl}/apartment/${selectedApt.replace('.', '-')}`))
            }
        },
        onLevelSelect: (selectedLevel) => {
            // return an onClick usable function that changes routes
            return () => {
                dispatch(hoverRemoveApartmentAction(null)); // dispatch a remove hover action to ensure if we navigate back, the hover is cleared
                dispatch(push(`/apartments/level/${selectedLevel}`));
            };
        },
        onSoldButtonLoaded: (apt, elem) => {
            //let svg = elem.parentElement.getElementsByTagName('svg');
            let svgOutline = document.querySelector(`[data-key="${apt.apartment}"]`);
            let svg = svgOutline.nearestViewportElement;
            let bbox = svgOutline.getBBox();

            let point = svg.createSVGPoint();
            point.x = bbox.x;
            point.y = bbox.y;

            // apply matrix transformation to get the x/y coords we want
            let newPoint = point.matrixTransform(svgOutline.getCTM());

            let position = {
                'top': `${(newPoint.y + (svgOutline.getBBox().height / 2)) - 11}px`,
                'left': `${(newPoint.x  + (svgOutline.getBBox().width / 2)) - 34}px`
            };

            elem.style.top = position.top;
            elem.style.left = position.left;
            if(apt.status === 1) {
                elem.style.display = 'none';
            }
        },
        onSideBoxLoaded: (apt, elem) => {
            let svgOutline = document.querySelector(`[data-key="${apt.apartment}"]`);
            let bbox = svgOutline.getBBox(); // get the bounding box
            let svg = svgOutline.nearestViewportElement; // get pointer to svg container

            let point = svg.createSVGPoint(); // create an svg point at the bounding box x and y positions
            point.x = bbox.x;
            point.y = bbox.y;

            // apply matrix transformation to get the x/y coords we want
            let newPoint = point.matrixTransform(svgOutline.getCTM());

            // get the centerpoint of the svg so we can work out if we are on the left or right of the image
            let svgCenterX = Math.floor(svg.getBoundingClientRect().width / 2);

            // our Y position is always the points y offset from the svg 0,0
            let popupBoxPosition = {
                top: `${newPoint.y + (svgOutline.getBBox().height / 4)}px` // height / 4 gives us a quarter increment, plus the half increment on the line should be roughly half of outline size
            };

            // if the centerpoint of the hovered element is less than the centerpoint of the svg, then the hovered element is on the left-hand side of the page
            // otherwise it is on the right hand side of the page. Remember to set the opposite to auto when not in use otherwise your dom element will stretch
            let hoverboxPointerLine = elem.querySelector('.hoverbox-pointer');
            if(newPoint.x <= svgCenterX) {
                popupBoxPosition.left = `20px`;
                popupBoxPosition.right = `auto`;
                hoverboxPointerLine.style.right = `-110px`;
                hoverboxPointerLine.style.left = `auto`;
            } else {
                popupBoxPosition.left = `auto`;
                popupBoxPosition.right = `20px`;
                hoverboxPointerLine.style.left = `-110px`;
                hoverboxPointerLine.style.right = `auto`;
            }

            elem.style.top = popupBoxPosition.top;
            elem.style.left = popupBoxPosition.left;
            elem.style.right = popupBoxPosition.right;
        },
        onHoverApartment: (apt) => {
            return (evt) => {
                let popupBoxPosition = {};
                let payload = {
                    apt,
                    popupBoxPosition
                };

                // dispatch the payload
                document.querySelector(`[data-boxkey='${apt.apartment}']`).classList.add('hover');
                dispatch(hoverApartmentAction(payload));
            }
        },
        onHoverRemoveApartment: (apt) => {
            return (evt) => {
                // dispatching a null action will clear any hover states
                document.querySelector(`[data-boxkey='${apt.apartment}']`).classList.remove('hover');
                dispatch(hoverRemoveApartmentAction(null));
            }
        }
    };
};

// this function performs all the hookups that allow the above mapping to happen
const ApartmentSelectPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(_ApartmentSelectPage);

export default ApartmentSelectPage;


// WEBPACK FOOTER //
// ./src/pages/apartment-select/ApartmentSelectPage.js